
import {getProductByID, toPlantation } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function AluminiumPlantationShutterPage() {

  return (
      GenericProductPage(getProductByID(46),toPlantation)
  )
}
